export default {"src":"https://fishbrain.com/_next/static/media/illinois.eef6fb3b.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};